import styled from "styled-components";

const StyledHeaderPanel = styled.div`
  border: 1px solid #e2e2e4;
  padding: 10px 16px;
  border-radius: 0.5rem;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02);
  margin-bottom: 2rem;
  display: flex;
  gap: 16px;
  color: #706f7b !important;
`;

export function HeaderPanel() {
  return (
    <StyledHeaderPanel>
      <i className="pi pi-info-circle" style={{ marginTop: "3px" }} />
      <span className="text-sm font-normal text-left  mb-0">
        {`If your balance changes after insurance processes your claims, we'll
          update your plan to reflect the final amounts.`}
      </span>
    </StyledHeaderPanel>
  );
}
